import { apiUrl } from '../config/api'

// Society-level document management — currently just the "literal" (the
// corporate registry excerpt with the society's official general data),
// kept separate from per-compliance documents (see societyComplianceDocuments.js).
//
// NOTE: these endpoints (UploadSocietyLiteralDocument, GetSocietyLiteralDocument,
// GenerateSocietyLiteralDocumentUrl, DeleteSocietyLiteralDocument) are new —
// they don't exist yet in the Azure Functions backend and need to be added
// there before this works end-to-end.

export async function uploadSocietyLiteralDocument({ file, societyId, loggedUserId }) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('societyId', societyId)
  formData.append('loggedUserId', loggedUserId)
  formData.append('brandLabel', window.$brand)

  let url = apiUrl('UploadSocietyLiteralDocument')

  try {
    let res = await fetch(url, {
      method: 'POST',
      body: formData
    }).catch((error) => console.log(error))

    if (!res) return null
    const text = await res.text()
    return text ? JSON.parse(text) : { status: res.status }
  } catch (err) {
    console.error('Upload error:', err)
    return null
  }
}

export async function getSocietyLiteralDocument(societyId) {
  let params = { societyId, brandLabel: window.$brand }
  let url = apiUrl('GetSocietyLiteralDocument')

  let res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params)
  }).catch((error) => console.log(error))

  if (!res) return null
  const text = await res.text()
  return text ? JSON.parse(text) : null
}

export async function generateSocietyLiteralDocumentUrl(societyId) {
  let url = apiUrl('GenerateSocietyLiteralDocumentUrl')
  const res = await fetch(`${url}&societyId=${societyId}`)
  return res.json()
}

export async function deleteSocietyLiteralDocument(societyId, loggedUserId) {
  let params = { societyId, loggedUserId, brandLabel: window.$brand }
  let url = apiUrl('DeleteSocietyLiteralDocument')

  let res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params)
  }).catch((error) => console.log(error))

  if (!res) return null
  const text = await res.text()
  return text ? JSON.parse(text) : { status: res.status }
}
